import { nonEmptyString } from '../../lib/format';
import type { ClioMatter } from '../../types';
import React from 'react';
import { CrudActivityIndicator } from '../CrudActivityIndicator';
import { AIExtractionProgress } from './AIExtractionProgress';
import './ai-extraction-progress.css';

// Implements App.tsx's topbar (matter breadcrumb, save activity, and avatar
// that opens the user-preferences slide-over).

export interface AppTopbarProps {
  clioMatter: Pick<ClioMatter, 'client' | 'description'> | null;
  activeStageId: string;
  onOpenUserPrefs: () => void;
  matterId?: string;
  onOpenAIExtract?: () => void;
}

export function AppTopbar({ clioMatter, activeStageId, onOpenUserPrefs, matterId, onOpenAIExtract }: AppTopbarProps): React.JSX.Element {
  return (
    <div className="topbar">
      <div className="crumb">
        <b>{(nonEmptyString(clioMatter?.client) ?? 'Matter Client')}</b>
        <span className="sep">/</span>
        <span>{(nonEmptyString(clioMatter?.description) ?? 'Description')}</span>
        <span className="side-indicator">{activeStageId}</span>
      </div>

      <div className="spacer"></div>

      {matterId && onOpenAIExtract && <AIExtractionProgress matterId={matterId} onOpenAIExtract={onOpenAIExtract} />}
      <CrudActivityIndicator />
      <button
        type="button"
        className="avatar"
        onClick={onOpenUserPrefs}
        aria-label="Open user preferences"
        title="User Preferences"
        style={{ cursor: 'pointer' }}
      >⚙</button>
    </div>
  );
}
